import React from 'react';
import { reduxForm, Field, reset } from 'redux-form';
import {
  combineValidators,
  isRequired,
  createValidator,
  composeValidators,
  hasLengthGreaterThan,
} from 'revalidate';
import LoginTextInput from '../common/form/LoginTextInput';
import { toastr } from 'react-redux-toastr';

let newPassword;
const handleOnFormChange = (newValues, dispatch, props, previousValues) => {
  const { newPass: newNewPass } = newValues;
  newPassword = newNewPass;
};

const isPassEqual = createValidator(
  (message) => (value) => {
    if (value && value !== newPassword) {
      return message;
    }
  },
  'Password tidak sama!'
);

const isAlphaNum = createValidator(
  (message) => (value) => {
    if (value && !value.match(/^[0-9a-z]+$/)) {
      return message;
    }
  },
  'Password karakter harus huruf atau angka'
);

const validate = combineValidators({
  newPass: composeValidators(
    isRequired({ message: 'Password baru harus diisi' }),
    hasLengthGreaterThan(3)({
      message: 'Password harus memiliki paling sedikit 4 karakter',
    }),
    isAlphaNum
  )(),
  confirmPass: composeValidators(
    isRequired({ message: 'Konfirmasi password harus diisi' }),
    isPassEqual
  )(),
});

function ResetPasswordForm({
  auth,
  loading,
  history,
  dispatch,
  initialValues,
  isExpired,
  setNotif,
  handleSubmit,
  error,
  invalid,
  pristine,
  resetPasswordAuth,
}) {
  async function handleResetPassword(values) {
    if (isExpired) {
      return toastr.warning(
        'Peringatan',
        'Link ini telah expired, lakukan request reset password kembali!'
      );
    }

    let newValues = {
      token: initialValues.token,
      username: initialValues.username,
      email: initialValues.email,
      password: values.newPass,
    };
    let res = await resetPasswordAuth(history, newValues);
    if (res === 'success') {
      setNotif(true);
      dispatch(reset('formResetPassword'));
    }
  }
  return (
    <div>
      <form onSubmit={handleSubmit(handleResetPassword)} autoComplete='off'>
        <Field
          name='username'
          type='text'
          component={LoginTextInput}
          placeholder='Username'
          autoComplete='new-password'
          label='Username'
          icon='account'
          readOnly={true}
        />
        <Field
          name='newPass'
          type='password'
          autoComplete='new-password1'
          component={LoginTextInput}
          placeholder='Password Baru'
          label='Password Baru'
          icon='lock'
          disabled={isExpired}
        />
        <Field
          name='confirmPass'
          type='password'
          autoComplete='new-password2'
          component={LoginTextInput}
          placeholder='Konfirmasi Password'
          label='Konfirm Password'
          icon='lock'
          disabled={isExpired}
        />
        <div className='field has-text-centered mt-5'>
          {error && <p className='help is-danger'>{error}</p>}
          <button
            type='submit'
            disabled={invalid || loading || pristine || isExpired}
            className={`mr-3 button is-info is-small is-rounded${
              loading ? ' is-loading' : ''
            }`}
          >
            Simpan
          </button>
        </div>
      </form>
    </div>
  );
}

export default reduxForm({
  form: 'formResetPassword',
  onChange: handleOnFormChange,
  validate,
})(ResetPasswordForm);
